import { utils, writeFile } from "xlsx";
import { formatarDataSemFuso } from "../../utils/formatDate";

export function useExportToExcel() {
    const exportToExcel = (data, columns, filename = "exportacao") => {
        // Monta cabeçalhos e linhas usando as mesmas regras de formato da tabela
        const headers = columns
            .filter((col) => col.exportable !== false)
            .map((col) => col.label);

        const rows = data.map((row) =>
            columns
                .filter((col) => col.exportable !== false)
                .map((col) => {
                    const value = row[col.key];
                    if (value == null) return "";
                    if (col.exportRaw) return value; // permite exportar valor bruto
                    switch (col.format) {
                        case "percent":
                            return typeof value === "number" ? value / 100 : value;
                        case "currency":
                        case "number":
                            return typeof value === "number" ? value : String(value);
                        case "date":
                            return typeof value === "string"
                                ? formatarDataSemFuso(value)
                                : String(value);
                        case "boolean":
                            return value ? "Sim" : "Não";
                        default:
                            return String(value);
                    }
                })
        );

        const worksheet = utils.aoa_to_sheet([headers, ...rows]);

        // Formata colunas de percentual corretamente no Excel
        columns
            .filter((col) => col.exportable !== false && col.format === "percent")
            .forEach((col, i) => {
                const colIndex = columns.filter((c) => c.exportable !== false).indexOf(col);
                for (let r = 1; r <= rows.length; r++) {
                    const cellRef = utils.encode_cell({ r, c: colIndex });
                    if (worksheet[cellRef]) {
                        worksheet[cellRef].z = "0.00%";
                    }
                }
            });

        // Auto largura das colunas
        worksheet["!cols"] = headers.map((h, i) => {
            const maxLen = Math.max(
                h.length,
                ...rows.map((r) => String(r[i] ?? "").length)
            );
            return { wch: Math.min(maxLen + 2, 50) };
        });

        const workbook = utils.book_new();
        utils.book_append_sheet(workbook, worksheet, "Dados");
        writeFile(workbook, `${filename}.xlsx`);
    };

    return { exportToExcel };
}